import { ProjectDetailState } from '../state';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { AppConfig } from '../../../../data/terra/AppConfig';

const UPDATE_APP_CONFIG = 'project/appConfigs/update';

export interface UpdateAppConfigAction {
  type: typeof UPDATE_APP_CONFIG;
  appConfig: AppConfig;
}

export const updateAppConfig =
  (
    appConfig?: AppConfig
  ): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: UPDATE_APP_CONFIG,
      appConfig,
    } as UpdateAppConfigAction);
  };

export const updateAppConfigDelegate: DelegateMapEntry<
  UpdateAppConfigAction,
  ProjectDetailState
> = {
  [UPDATE_APP_CONFIG]: (
    state: ProjectDetailState,
    action: UpdateAppConfigAction
  ): ProjectDetailState => {
    const appConfigs = state.appConfigs.data;
    const currentEnv = state.selectedEnv;

    appConfigs?.forEach((config, index) => {
      if (currentEnv?.id === config.env.id) {
        appConfigs[index] = action.appConfig;
      }
    });

    return {
      ...state,
      selectedAppConfig: action.appConfig,
    };
  },
};
